import {
  AfterContentInit,
  Component,
  ElementRef,
  HostListener,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'sag-ui-focus-trap',
  template: `<div #start></div>
    <div class="outline-none w-full">
      <ng-content></ng-content>
    </div>
    <div #end></div>`,
})
export class FocusTrapComponent implements AfterContentInit {
  @ViewChild('start', { static: true }) start: ElementRef | undefined;
  @ViewChild('end', { static: true }) end: ElementRef | undefined;

  private focusableElements: HTMLElement[] = [];

  constructor(private elRef: ElementRef) {}

  ngAfterContentInit(): void {
    setTimeout(() => {
      this.focusableElements = this.getFocusableElements();
      this.focusFirstElement();
    }, 100);
  }

  private getFocusableElements(): HTMLElement[] {
    const focusableSelectors =
      'a[href], button, textarea, input, select, [tabindex]:not([tabindex="-1"])';
    const elements =
      this.elRef.nativeElement.querySelectorAll(focusableSelectors);
    return Array.from(elements) as HTMLElement[];
  }

  @HostListener('keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    const isTabPressed = event.key === 'Tab';

    if (!isTabPressed) {
      return;
    }

    const firstElement = this.focusableElements[0];
    const lastElement =
      this.focusableElements[this.focusableElements.length - 1];

    if (event.shiftKey) {
      // Shift + Tab
      if (document.activeElement === firstElement) {
        lastElement.focus();
        event.preventDefault();
      }
    } else {
      // Tab
      if (document.activeElement === lastElement) {
        firstElement.focus();
        event.preventDefault();
      }
    }
  }

  focusFirstElement() {
    if (this.focusableElements && this.focusableElements.length > 0) {
      this.focusableElements[0].focus();
    }
  }
}
